// extracted by css-extract-rspack-plugin
var _1 = "VgQzFsYrTgbUEd4s";
var _2 = "VgQzFsYrTgbUEd4s";
export { _1 as "ueftv-carousel", _2 as "ueftvCarousel" }
